import { IconButton, Typography } from "@suraasa/placebo-ui"
import CPDAnnual from "assets/WelcomeDialogOnboarding/PgCTL/BuildCareer/cpd.webp"
import SkillPortfolio from "assets/WelcomeDialogOnboarding/PgCTL/BuildCareer/skill-portfolio.webp"
import { Xmark } from "iconoir-react"

const BuildCareer = ({ handleClose }: { handleClose: () => void }) => {
  return (
    <div className="p-4">
      <div className="flex items-start justify-between">
        <Typography variant="title3" className="mb-3 max-w-[218px]">
          A Program Built for Your Career
        </Typography>
        <IconButton color="black" onClick={handleClose}>
          <Xmark />
        </IconButton>
      </div>
      <div className="mb-2 flex flex-col-reverse rounded-2xl bg-surface-100 sm:flex-row">
        <div className="px-3 py-2.5 sm:py-[45px] sm:pl-3 sm:pr-0">
          <Typography variant="strongSmallBody" className="mb-1">
            Fulfill Your Annual CPD
          </Typography>
          <Typography variant="smallBody" className="text-onSurface-600">
            With PgCTL, you meet your yearly CPD requirements through one
            globally recognised program. No more scrambling for last-minute
            workshops or certificates.
          </Typography>
        </div>
        <div className="grid min-h-full shrink-0 place-items-center rounded-r-2xl  bg-[radial-gradient(circle_at_70%_20%,rgba(160,210,250,0.3)_0,transparent_55%),radial-gradient(circle_at_70%_80%,rgba(255,194,253,0.3)_0,transparent_55%)] py-2.25 sm:px-2.5 sm:py-0">
          <img
            src={CPDAnnual}
            alt="cpd-annual"
            className="size-[111px] shrink-0"
          />
        </div>
      </div>

      <div className="mb-2 flex flex-col-reverse rounded-2xl bg-surface-100 sm:flex-row">
        <div className="px-3 py-2.5 sm:py-[45px] sm:pl-3 sm:pr-0">
          <Typography variant="strongSmallBody" className="mb-1">
            Build Your Verified Skill Portfolio
          </Typography>
          <Typography variant="smallBody" className="text-onSurface-600">
            Your Skill Portfolio Portal captures proof of your teaching skills,
            validated by experts and ready to share with employers.
          </Typography>
        </div>
        <div className="grid min-h-full shrink-0 place-items-center rounded-r-2xl  bg-[radial-gradient(circle_at_70%_40%,rgba(255,71,160,0.15)_0,transparent_40%),radial-gradient(circle_at_70%_20%,rgba(160,210,250,0.3)_0,transparent_55%),radial-gradient(circle_at_70%_80%,rgba(255,194,253,0.3)_0,transparent_55%)] py-2.25 sm:bg-[radial-gradient(circle_at_70%_40%,rgba(255,71,160,0.25)_0,transparent_55%),radial-gradient(circle_at_70%_20%,rgba(160,210,250,0.3)_0,transparent_55%),radial-gradient(circle_at_70%_80%,rgba(255,194,253,0.3)_0,transparent_55%)] sm:px-2.5 sm:py-0">
          <img
            src={SkillPortfolio}
            alt="skill-portfolio"
            className="h-[127px] shrink-0"
          />
        </div>
      </div>
    </div>
  )
}

export default BuildCareer
